import React from 'react'
import '../css/footer.css'
import { ReactComponent as Logo } from '../assets/footerLogo.svg'
import { useT } from '../context/LanguageContext'

function Footer() {
  const { t } = useT()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-black shadow dark:bg-gray-900 landscape:py-2">
      <div className="w-full max-w-full mx-auto md:py-8 landscape:py-3">
        <div className="flex flex-col items-center sm:flex-row sm:items-center sm:justify-between px-[10%]">
          <a className="flex items-center justify-center sm:justify-start sm:mb-0 space-x-3 rtl:space-x-reverse no-underline">
            <Logo />
            <span className="text-2xl font-semibold whitespace-nowrap dark:text-white no-underline text-white">
              Raul Flores
            </span>
          </a>
          <ul className="flex flex-wrap justify-center items-center gap-6 pl-0 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
            <li>
              <a href="#" className="no-underline text-white">{t.footer.about}</a>
            </li>
            <li>
              <a href="https://www.termsfeed.com/live/7ed91749-da00-4992-b7c2-b03f18fb6808" className="no-underline text-white">{t.footer.privacy}</a>
            </li>
            <li>
              <a href="/contact" className="no-underline text-white">{t.footer.contact}</a>
            </li>
          </ul>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-6 landscape:my-2 no-underline" />
        <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400 no-underline text-center">
          © {currentYear}{' '}
          <a href="https://www.linkedin.com/in/raulfr99/" target="_blank" rel="noreferrer" className="no-underline text-white">
            raulfr99
          </a>
          . {t.footer.madeBy}
        </span>
      </div>
    </footer>
  )
}

export default Footer
